export default "__VITE_ASSET__C7F1_yVn__"